import {
  LockOutlined,
  UserOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';
import { Form, Button, Checkbox, Input, Layout, Spin, Row, Col } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import LanguageChooser from 'components/LanguageChooser';
import { useSelector, useDispatch } from 'react-redux';
import { getMessage } from 'utils';
import { doLogin, logout } from 'reducers/auth';
import './login.less';

export const LoginPage = () => {
  const [autoLogin, setAutoLogin] = React.useState(true);
  const isLoading = useSelector((stores) => stores.auth.isLoading);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleSubmit = async ({ password, username }) => {
    const u = String(username).trim();
    const p = String(password).trim();
    dispatch(
      doLogin({ username: u, password: p }, () => {
        history.replace('/');
      })
    );
  };

  React.useEffect(() => {
    localStorage.clear();
    dispatch(logout());
  }, []);

  return (
    <Spin spinning={isLoading}>
      <Layout>
        <div
          className={'container'}
          style={{
            backgroundImage: `url('/background.svg')`,
          }}
        >
          <div className={'content'}>
            <div className="container">
              <div className="content">
                <div className="top">
                  <div className="header">
                    <Link to="/">
                      <span className="title">
                        <img height="200" src={'/assets/images/b-logistics.png'} />
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="login" style={{ marginTop: '100px' }}>
                  <Form
                    onFinish={handleSubmit}
                    scrollToFirstError
                    initialValues={{ warehouse_id: '' }}
                  >
                    <Form.Item name="language">
                      <LanguageChooser compressed={false} />
                    </Form.Item>
                    <Form.Item
                      name="username"
                      rules={[
                        {
                          required: true,
                          message: getMessage(
                            'pages.auth.login.fields.username.required'
                          ),
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        name="username"
                        autoComplete="username"
                        prefix={
                          <UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />
                        }
                        placeholder={getMessage(
                          'pages.auth.login.fields.username.placeholder'
                        )}
                      />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: getMessage(
                            'pages.auth.login.fields.password.required'
                          ),
                        },
                      ]}
                    >
                      <Input
                        prefix={
                          <LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />
                        }
                        size="large"
                        autoComplete="password"
                        type="password"
                        placeholder={getMessage(
                          'pages.auth.login.fields.password.placeholder'
                        )}
                      />
                    </Form.Item>
                    {/*
                    <Form.Item
                      help="Kho nhận / gửi hàng"
                      name="warehouse_id"
                      rules={[
                        {
                          required: false,
                          message: 'Vui lòng chọn kho thao tác!',
                        },
                      ]}
                    >
                      <Select size="large" placeholder="Mã kho">
                        <Select.Option value={''}>
                          {getMessage(
                            'pages.common.warehouse_chooser.default_title'
                          )}
                        </Select.Option>
                        {map(warehouseList, (wh) => {
                          return (
                            <Select.Option value={wh.id}>
                              {wh.code} - {wh.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item> */}
                    {/* <Row gutter={24}>
                      <Col span={24}>
                        <Checkbox
                          checked={autoLogin}
                          onChange={changeAutoLogin}
                        >
                          Đăng nhập tự động
                        </Checkbox>
                         <a
                          href="#"
                          style={{
                            float: 'right',
                          }}
                        >
                          Quên mật khẩu
                        </a>
                      </Col>
                    </Row> */}
                    <Row gutter={24}>
                      <Col span={24}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          size="large"
                          style={{ marginTop: '10px', width: '100%' }}
                        >
                          {getMessage('common.button.login')}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </Spin>
  );
};

export default LoginPage;
